import React, { useState } from "react";
import TableMain from "../Common/table/TableMain";
import EwalletTableFilter from "../Common/table/EwalletTableFilter";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { EwalletService } from "../../services/ewallet/ewallet";

const EmoneyTable = (props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("statement");
  const [selectedStatement, setSelectedStatement] = useState(false);
  const [selectedEmoneyRequest, setSelectedEmoneyRequest] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [sortOptions, setSortOptions] = useState({ sortBy: "", direction: "" });
  //------------------------------------------- API -------------------------------------------

  // const purchaseHistory = ApiHook.CallPurchaseHistory(
  //   props.currentPage,
  //   itemsPerPage,
  //   selectedPurchase,
  //   setSelectedPurchase,
  //   sortOptions.sortBy,
  //   sortOptions.direction,
  //   activeTab
  // );

  const emoneyStatement = EwalletService.useEmoneyStatement(props.currentPage, itemsPerPage, activeTab);
  const requestHistory = EwalletService.useEmoneyRequestHistory(props.currentPage, itemsPerPage, activeTab);
  const emoneyTransfer = EwalletService.useEmoneyTransfer(props.currentPage, itemsPerPage, activeTab);

  const handleTabChange = (tab) => {
    setSortOptions({
      sortBy: "",
      direction: ""
    });
    setActiveTab(tab);
    props.setCurrentPage(1);
    setApiTab(tab);
  };
  
  const setApiTab = (tab) => {
    if (tab === "transfer_history") {
      setSelectedEmoneyRequest(true);
    } else {
      setSelectedStatement(true);
    }
  };

  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        <div className="ewallet_table_section_cnt_tab_head">
          <Link
            className={`ewallet_tab_btn ${activeTab === "statement" ? "active" : ""
              }`}
            onClick={() => handleTabChange("statement")}
          >
            {t("statement")}
          </Link>
          <Link
            className={`ewallet_tab_btn ${activeTab === "emoney_request" ? "active" : ""
              }`}
            onClick={() => handleTabChange("emoney_request")}
          >
            Emoney Request
          </Link>
          <Link
            className={`ewallet_tab_btn ${activeTab === "emoney_transfer" ? "active" : ""
              }`}
            onClick={() => handleTabChange("emoney_transfer")}
          >
            Emoney Transfer
          </Link>
        </div>
      </div>
      <div className="table-responsive min-hieght-table">
        {activeTab === "statement" && (
          <TableMain
            headers={['description', 'amount', 'transaction_date',  'balance']}
            data={emoneyStatement?.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={emoneyStatement?.data?.totalPages}
            setCurrentPage={props.setCurrentPage}
            type={"emoney"}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            activeTab={activeTab}
            setApiTab={setApiTab}
            setEpinSortOptions={setSortOptions}
          />
        )}
        {activeTab === "emoney_request" && (
          <TableMain
            headers={['date', 'request_amount', 'transaction_note', 'status', 'receipt', 'remarks']}
            data={requestHistory?.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={requestHistory?.data?.totalPages}
            setCurrentPage={props.setCurrentPage}
            type={"emoney"}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            activeTab={activeTab}
            setApiTab={setApiTab}
            setEpinSortOptions={setSortOptions}
          />
        )}
        {activeTab === "emoney_transfer" && (
          <TableMain
            headers={['transaction_note', 'amount', 'transaction_date', 'balance']}
            data={emoneyTransfer?.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={emoneyTransfer?.data?.totalPages}
            setCurrentPage={props.setCurrentPage}
            type={"emoney"}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            activeTab={activeTab}
            setApiTab={setApiTab}
            setEpinSortOptions={setSortOptions}
          />
        )}
      </div>
    </div>
  );
};

export default EmoneyTable;